import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const address = "5150 Linton Blvd, Suite 250, Delray Beach, FL 33484";
  const encodedAddress = encodeURIComponent(address);
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-info">
          <p className="footer-name">Boca-Delray Pathology Laboratories</p>
          <p>5150 Linton Blvd, Suite 250</p>
          <p>Delray Beach, FL 33484</p>
          <p>Phone: <a href="tel:+15616387577">(561) 638-7577</a></p>
          <p>Fax: (561) 638-9322</p>
          <p>Hours: Mon–Fri, 8 AM–5 PM</p>
          <p><a href={mapUrl} target="_blank" rel="noopener noreferrer" className="map-link">View on Google Maps</a></p>
        </div>
        <div className="footer-links">
          <Link to="/services">Services</Link>
          <Link to="/gi-pathology">GI Pathology</Link>
          <Link to="/histology-training">Histology Training</Link>
          <Link to="/referring-practices">Referring Practices</Link>
          <Link to="/team">Our Team</Link>
          <Link to="/contact">Contact</Link>
          <a href="https://bdp.labdynamo.com" target="_blank" rel="noopener noreferrer">Provider Portal</a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>{`© ${new Date().getFullYear()} Boca-Delray Pathology Laboratories. All rights reserved.`}</p>
        <p className="footer-privacy">Do not send protected health information through this website. Use the provider portal or call the laboratory. <Link to="/privacy-policy">Privacy Policy</Link></p>
      </div>
    </footer>
  );
}

export default Footer;
